<template>
  <div class="popup-wrapper">
    <div
      class="w-100 h-100"
      @click="goBack ? '' : $emit('close')"
    />
    <div class="popup">
      <div
        v-if="header"
        class="popup__header"
      >
        <h6 class="bold">
          <slot name="title">
            {{ title }}
          </slot>
        </h6>
        <a
          v-if="!goBack"
          class="ml-auto"
          @click="$emit('close')"
        >
          <GjIcon
            name="Close"
          />
        </a>
      </div>
      <div class="popup__body">
        <slot />
      </div>
      <div
        v-if="hasFooter"
        class="popup__footer"
      >
        <b-button
          v-if="cancel"
          variant="bg-white"
          class="mr-1"
          @click="$emit('close')"
        >
          Cancel
        </b-button>
        <b-button
          v-if="goBack"
          class="mr-1"
          variant="bg-white"
          @click="$emit('goBack')"
        >
          Go Back
        </b-button>
        <button-loading
          variant="bg-primary"
          :spinning="spinning"
          :disabled="disabled"
          @click="$emit('add')"
        >
          {{ buttonText }}
        </button-loading>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PopUp',
  props: {
    header: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: '',
    },
    buttonText: {
      type: String,
      default: 'Add',
    },
    spinning: {
      type: Boolean,
      default: false,
    },
    goBack: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    cancel: {
      type: Boolean,
      default: false,
    },
    hasFooter: {
      type: Boolean,
      default: true,
    },
  },
}
</script>
